import {gql} from '@apollo/client';

export const formattedAgeFragment = gql`
  fragment FormattedAgeFragment on FormattedAge {
    months
    years
  }
`;

export const testResultCategoryFragment = gql`
  fragment TestResultCategory on CategoryAssessment {
    category {
      id
      title
    }
    categoryScore
    id
    maxCategoryScore
  }
`;

export const testResultLabSubmissionFragment = gql`
  ${formattedAgeFragment}
  ${testResultCategoryFragment}

  fragment TestResultLabSubmission on LabSubmission {
    id
    labAssessment {
      bioAge
      chronologicalAge
      deltaAge
      formattedBioAge {
        ...FormattedAgeFragment
      }
      formattedChronologicalAge {
        ...FormattedAgeFragment
      }
      formattedDeltaAge {
        ...FormattedAgeFragment
      }
      id
    }
    registeredDate
    userSurveySubmission {
      id
      surveyAssessment {
        categories {
          ...TestResultCategory
        }
        id
        lifestyleScore
        maxLifestyleScore
      }
    }
  }
`;

export interface TestResultListItemProps {
  categories?: {
    title: string;
    categoryScore: number;
    id: string;
    maxCategoryScore: number;
  }[];
  count?: number;
  formattedBioAge?: {
    years: number;
    months: number;
  };
  formattedDeltaAge?: {
    years: number;
    months: number;
  };
  deltaAge?: number;
  id?: string;
  isCurrent?: boolean;
  lifestyleScore?: number;
  registeredDate?: string;
}
